type ParamsType = Record<string, string>;

export const fetchAll = async (
  url: string,
  token: string,
  params: ParamsType,
  pageLimit: number = 100,
) => {
  const ret = [];
  let page = 1;
  let hasNextPage = true;
  const fetchUrl = new URL(url);

  while (hasNextPage) {
    fetchUrl.search = new URLSearchParams({
      ...params,
      page: page.toString(),
    }).toString();

    const response = await fetch(fetchUrl.toString(), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }
    const data = await response.json();
    ret.push(...data);

    const xTotalPages = response.headers.get('x-total-pages');
    if (!xTotalPages) {
      throw new Error('Missing x-total-pages header');
    }
    hasNextPage = page < Number(xTotalPages) && page < pageLimit;
    page++;
  }
  return ret;
};
